import React from "react";
import { parseJSON } from "date-fns";
import differenceInDays from 'date-fns/differenceInDays';
import { FaExternalLinkAlt } from "react-icons/fa";

const calculateRemainingDays = (endDate) => {
  const remainingDays = differenceInDays(parseJSON(new Date(endDate)), new Date());
  return remainingDays > 0 ? remainingDays : 0
}

function StatusBar({offer}){
  return (
    <div style={{flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
      {
        offer?.deal?.close_date && offer.status === 'live' &&
        <span className="f-black fs-10">{calculateRemainingDays(offer.deal?.close_date)} days remaining</span>
      }

      <span
        className="btn-status-border-none text-capitalize me-3 fs-10"
      >
      <span className={`status-circle me-2 ${offer.status === 'live' ? 'bg-success' : 'bg-danger'}`} />
        {offer.status?.replaceAll("_", " ")}
      </span>

      <button
        className="btn btn-outline-light text-capitalize d-inline-flex align-items-center justify-content-center ml-2"
        style={{fontSize:'13px'}}
        onClick={() => window.open(`${process.env.REACT_APP_INVESTOR_APP_URL}/offers/${offer.slug}`, "_blank") }
      >
          View <FaExternalLinkAlt className="ms-2"/>
      </button>
    </div>
  )
}

export default StatusBar;